import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="px-4 md:px-6 py-8">
      <div className="rounded-2xl bg-[#0A0A0F] px-6 md:px-10 lg:px-16 py-12 md:py-16 relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.04]">
          <span className="font-heading text-[180px] md:text-[240px] font-extrabold text-white whitespace-nowrap">
            OOPBUY
          </span>
        </div>

        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl text-white font-semibold mb-6">
              OOPBuy Spreadsheet
            </h3>
            <p className="text-sm text-white/50 leading-relaxed">
              Smart sourcing for serious buyers. The complete OOPBuy Spreadsheet system for tracking inventory across 14 product categories.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Navigate</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                Home
              </Link>
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                Categories
              </a>
              <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                Articles
              </Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                Buy Now
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Social</h4>
            <div className="flex flex-col gap-3">
              <a href="#" className="flex items-center gap-2 text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base"></i>
                <span>Instagram</span>
              </a>
              <a href="#" className="flex items-center gap-2 text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-base"></i>
                <span>YouTube</span>
              </a>
              <a href="#" className="flex items-center gap-2 text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-base"></i>
                <span>Facebook</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-1">
            <p className="text-white text-sm mb-3">Get updates on new drops.</p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d8sean4jgj4v45gj7jvg"
              method="POST"
              className="flex gap-0"
            >
              <input
                type="email"
                name="email"
                placeholder="Email address"
                required
                className="h-11 px-4 bg-white/5 border border-white/10 rounded-l-full text-sm text-white placeholder:text-white/30 outline-none focus:border-white/30 transition-colors flex-1 min-w-0"
              />
              <button
                type="submit"
                className="h-11 w-11 bg-white rounded-r-full flex items-center justify-center shrink-0 cursor-pointer hover:bg-white/90 transition-colors"
              >
                <i className="ri-arrow-right-line text-foreground-950 text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="relative z-10 mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-white/20">
            oopbuyspreadsheets.rest
          </p>
        </div>
      </div>
    </footer>
  );
}